import { render, staticRenderFns } from "./assist-anti-fraud-case-stay.vue?vue&type=template&id=75ed58f6"
import script from "./assist-anti-fraud-case-stay.vue?vue&type=script&lang=ts"
export * from "./assist-anti-fraud-case-stay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports